const list = {
    or: 'или',
    and: 'и',
    separator: ',',
};
export default Object.freeze(list);
